module OfficeExt {
  export class ManifestUtil {
    static isSameId(id1: string, id2: string): boolean {
      return id1?.toLowerCase() == id2?.toLowerCase();
    }
    static versionLessThan(version1, version2): boolean {
      return OSF.OsfManifestManager.versionLessThan(version1, version2);
    }
    static IsManifestFromXMLString(manifest: string | Manifest): boolean {
      if (typeof manifest === "string") {
        return true;
      }
      return false;
    }
    static ParseManifest(para, uiLocale, correlation?: string): Manifest {
      try {
        // @ts-expect-error TS2741
        return new OSF.Manifest.Manifest(para, uiLocale);
      } catch (ex) {
        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
          "Invalid manifest:",
          ex,
          correlation,
          0x1f01139f /* tag_5aro5 */,
        );
        return null;
      }
    }
    static IsManifestFromAcquisitionForMos(manifest: string | Mos.Acquisition) {
      if (typeof manifest !== "string") {
        return manifest?.titleDefinition?.elementDefinitions?.extensions?.length > 0;
      }
      return false;
    }
    static ParseManifestFromAcquisitionForMos(
      manifest: Mos.Acquisition,
      uiLocale,
      correlation?: string,
    ): Mos.AppMetadata {
      try {
        return Mos.AppMetadata.fromAcquisition(manifest, uiLocale);
      } catch (ex) {
        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
          "Invalid manifest:",
          ex,
          correlation,
          0x1e35c85a /* tag_4n270 */,
        );
      }
      return null;
    }
    static constructAddInId(solutionId: string, version: string, storeTypeName: string, storeLocation: string): string {
      const addinIdFormat = "{0}|{1}|{2}|{3}|{4}|||";
      const addinIdFormatVersion = "2";
      return OfficeExt.MsAjaxString.format(
        addinIdFormat,
        addinIdFormatVersion,
        solutionId,
        version,
        this.GetStoreTypeId(storeTypeName).toString(),
        storeLocation,
      );
    }
    private static GetStoreTypeId(storeTypeName: string): number {
      if (storeTypeName == OSF.StoreType.OMEX) {
        return OSF.StoreTypeEnum.MarketPlace;
      } else if (storeTypeName == OSF.StoreType.SPCatalog) {
        return OSF.StoreTypeEnum.Catalog;
      } else if (storeTypeName == OSF.StoreType.SPApp) {
        return OSF.StoreTypeEnum.SPApp;
      } else if (storeTypeName == OSF.StoreType.Exchange) {
        return OSF.StoreTypeEnum.Exchange;
      } else if (storeTypeName == OSF.StoreType.FileSystem) {
        return OSF.StoreTypeEnum.FileSystem;
      } else if (storeTypeName == OSF.StoreType.Registry) {
        return OSF.StoreTypeEnum.Registry;
      } else if (storeTypeName == OSF.StoreType.PrivateCatalog) {
        return OSF.StoreTypeEnum.PrivateCatalog;
      } else if (storeTypeName == OSF.StoreType.HardCodedPreinstall) {
        return OSF.StoreTypeEnum.HardCodedPreinstall;
      } else if (storeTypeName == OSF.StoreType.FirstParty) {
        return OSF.StoreTypeEnum.FirstParty;
      } else if (storeTypeName == OSF.StoreType.UploadFileDevCatalog) {
        return OSF.StoreTypeEnum.UploadFileDevCatalog;
      } else if (storeTypeName == OSF.StoreType.WopiCatalog) {
        return OSF.StoreTypeEnum.WopiCatalog;
      } else if (storeTypeName == OSF.StoreType.MosExtra) {
        return OSF.StoreTypeEnum.MosExtra;
      }
      return -1;
    }
    static GetStoreTypeName(storeType: string): string {
      var storeTypeId = parseInt(storeType);
      if (storeTypeId == OSF.StoreTypeEnum.MarketPlace) {
        return OSF.StoreType.OMEX;
      } else if (storeTypeId == OSF.StoreTypeEnum.Catalog) {
        return OSF.StoreType.SPCatalog;
      } else if (storeTypeId == OSF.StoreTypeEnum.SPApp) {
        return OSF.StoreType.SPApp;
      } else if (storeTypeId == OSF.StoreTypeEnum.Exchange) {
        return OSF.StoreType.Exchange;
      } else if (storeTypeId == OSF.StoreTypeEnum.FileSystem) {
        return OSF.StoreType.FileSystem;
      } else if (storeTypeId == OSF.StoreTypeEnum.Registry) {
        return OSF.StoreType.Registry;
      } else if (storeTypeId == OSF.StoreTypeEnum.PrivateCatalog) {
        return OSF.StoreType.PrivateCatalog;
      } else if (storeTypeId == OSF.StoreTypeEnum.HardCodedPreinstall) {
        return OSF.StoreType.HardCodedPreinstall;
      } else if (storeTypeId == OSF.StoreTypeEnum.FirstParty) {
        return OSF.StoreType.FirstParty;
      } else if (storeTypeId == OSF.StoreTypeEnum.UploadFileDevCatalog) {
        return OSF.StoreType.UploadFileDevCatalog;
      } else if (storeTypeId == OSF.StoreTypeEnum.WopiCatalog) {
        return OSF.StoreType.WopiCatalog;
      } else if (storeTypeId == OSF.StoreTypeEnum.MosExtra) {
        return OSF.StoreType.MosExtra;
      }
      return null;
    }
  }
  export class AsyncUtil {
    static Cache: {
      [key: string]: string;
    } = {};
    static NextCheckExpiry: number = 0;
    static failed<TResult, TComplete>(
      result: IAsyncResult<TResult>,
      onComplete: (asyncResult: IAsyncResult<TComplete>) => void,
      value?: TComplete,
    ): boolean {
      if (result.status != DataServiceResultCode.Succeeded) {
        var r: IAsyncResult<TComplete> = { status: result.status, httpStatus: result.httpStatus };
        if (value != null) {
          r.value = value;
        }
        onComplete(r);
        return true;
      }
      return false;
    }
    // Retry the async operation if it failed, delaying each attempt exponentially
    static retry<T>(operation: () => Promise<T>, options = {} as any): Promise<T> {
      const { retries = 3, factor = 2, minTimeout = 300, maxTimeout = Infinity } = options;
      return new Promise((resolve, reject) => {
        const attempt = (count) => {
          operation().then(resolve, (err) => {
            if (count >= retries) {
              reject(err);
              return;
            }
            setTimeout(() => attempt(count + 1), Math.min(minTimeout * Math.pow(factor, count), maxTimeout));
          });
        };
        attempt(0);
      });
    }
    // Return a function that behave the same as the 'func' parameter, except that
    // it will wait fo the time specified in the 'wait' paramter between any two invocation.
    static limitRate(func: Function, wait: number): Function {
      const taskQueue = [];
      let lastRunTask = -Infinity;
      const runTaskQueue = () => {
        const args = taskQueue.shift();
        if (taskQueue.length > 0) {
          setTimeout(runTaskQueue, wait);
        }
        lastRunTask = performance.now();
        func(...args);
      };
      return (...args) => {
        if (taskQueue.length === 0) {
          setTimeout(runTaskQueue, Math.max(0, wait - (performance.now() - lastRunTask)));
        }
        taskQueue.push(args);
      };
    }
    // Cache the async operation result using the cacheKey. If it already exists, just return the cached entry as a resolved Promise.
    // Otherwise trigger the async operation and store in memory and localStorage cache
    // The localStorage cache will be expired after the maxAge second has passed (default 3 days)
    static withCache(
      cacheKey: string,
      options: {
        forceUpdateCache?: boolean;
        maxAgeInSecs?: number;
        useStaleCache?: boolean;
      },
      operation: () => Promise<string>,
    ): Promise<{
      cacheType: string;
      value: string;
    }> {
      const {
        forceUpdateCache = false,
        maxAgeInSecs = 60 * 60 * 24 * 3 /* default 3 days */,
        useStaleCache = false,
      } = options;
      if (!forceUpdateCache && AsyncUtil.Cache.hasOwnProperty(cacheKey)) {
        return Promise.resolve({
          cacheType: "memory",
          value: AsyncUtil.Cache[cacheKey],
        });
      }
      const cacheKeyWithPrefix = `__OSF_AsyncCache_${cacheKey}`;
      const cacheKeyWithPrefixStale = `__OSF_AsyncCache_${cacheKey}_stale`;
      const expiriesKey = `__OSF_AsyncCacheExpiry`;
      const now = Date.now();

      if (OSF.OUtil.getLocalStorage().isLocalStorageAvailable()) {
        try {
          if (now >= AsyncUtil.NextCheckExpiry) {
            const expiries = JSON.parse(localStorage.getItem(expiriesKey)) || {};
            let needUpdateExpiries = false;
            AsyncUtil.NextCheckExpiry = Infinity;
            // purge expired entries
            for (const key in expiries) {
              if (now > expiries[key]) {
                localStorage.removeItem(`__OSF_AsyncCache_${key}`);
                delete expiries[key];
                needUpdateExpiries = true;
              } else {
                AsyncUtil.NextCheckExpiry = Math.min(AsyncUtil.NextCheckExpiry, expiries[key]);
              }
            }
            if (needUpdateExpiries) {
              localStorage.setItem(expiriesKey, JSON.stringify(expiries));
            }
          }
          if (!forceUpdateCache && localStorage.hasOwnProperty(cacheKeyWithPrefix)) {
            return Promise.resolve({
              cacheType: "localStorage",
              value: localStorage.getItem(cacheKeyWithPrefix),
            });
          }
        } catch (e) {
          Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
            `failed to get key ${cacheKeyWithPrefix}`,
            e,
            null,
            0x1f01139e /* tag_5aro4 */,
          );
        }
      }
      return operation().then(
        (result) => {
          AsyncUtil.Cache[cacheKey] = result;
          try {
            const expiries = JSON.parse(localStorage.getItem(expiriesKey)) || {};
            expiries[cacheKey] = now + maxAgeInSecs * 1000;
            AsyncUtil.NextCheckExpiry = Math.min(AsyncUtil.NextCheckExpiry, expiries[cacheKey]);
            localStorage.setItem(expiriesKey, JSON.stringify(expiries));
            localStorage.setItem(cacheKeyWithPrefix, result);
            localStorage.setItem(cacheKeyWithPrefixStale, result);
          } catch (e) {
            // localstorage inaccessible due to privacy setting
          }
          return {
            cacheType: "none",
            value: result,
          };
        },
        (ex) => {
          if (useStaleCache && OSF.OUtil.getLocalStorage().isLocalStorageAvailable()) {
            if (localStorage.hasOwnProperty(cacheKeyWithPrefixStale)) {
              Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                `stale cache used for ${cacheKeyWithPrefixStale}`,
                null,
                0x1f01139d /* tag_5aro3 */,
              );
              return Promise.resolve({
                cacheType: "localStorage",
                value: localStorage.getItem(cacheKeyWithPrefixStale),
              });
            }
          }
          throw ex;
        },
      );
    }
  }
  class CatalogFactoryImp {
    private static _registry = {};
    private static _resolved = {};
    private static _hostInfo: IHostContextInfo;
    static register(storeType: string, creator: (hostInfo: IHostContextInfo) => IAddinCatalog): void {
      this._registry[storeType] = creator;
    }
    static resolve(storeType: string, hostInfo?: IHostContextInfo): IAddinCatalog {
      var catalog = this._resolved[storeType];
      if (catalog != null) {
        return catalog;
      }
      hostInfo = hostInfo || this._hostInfo;
      if (hostInfo != null) {
        var creator = this._registry[storeType];
        if (creator == null) {
          return null;
        }
        this._resolved[storeType] = catalog = creator(hostInfo);
      }
      return catalog;
    }
    static setHostContext(hostInfo: IHostContextInfo) {
      this._hostInfo = hostInfo;
    }
    static getHostContext(): IHostContextInfo {
      return this._hostInfo;
    }
  }
  OfficeExt.CatalogFactory = CatalogFactoryImp;
}
